import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './Routes/App';
import { GoogleOAuthProvider } from '@react-oauth/google';

// eslint-disable-next-line no-unused-vars
import * as serviceWorker from './serviceWorker'; // Do not remove or comment this line
// Reason: as we have customise service worker file so, this will call service worker file from here

ReactDOM.render(
    <GoogleOAuthProvider 
    clientId='936072113947-vnecn8e29hja0dfgofj3214ih7rloq8u.apps.googleusercontent.com'
    cookiePolicy={"single_host_origin"}
    >
    <App />
    </GoogleOAuthProvider>
    , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
